import React, { Component } from "react";
import PropTypes from "prop-types";
import SearchMenu from "./SearchMenu";

import { Item, Separator } from "@zendeskgarden/react-menus";

import gql from "graphql-tag";
import { Query } from "react-apollo";

const userSegmentsQuery = gql`
  query UserSegments($name: String) {
    userSegments(query: { name: $name }) {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`;

export default class UserSegmentsMenu extends Component {
  static propTypes = {
    getItemProps: PropTypes.func.isRequired,
    focusedKey: PropTypes.string,
  };

  state = { searchText: "" };

  onSearchTextChanged = searchText => {
    this.setState({ searchText });
  };

  render() {
    const { searchText } = this.state;
    const { getItemProps, focusedKey } = this.props;

    return (
      <SearchMenu>
        <SearchMenu.Input onChange={this.onSearchTextChanged} />
        <Separator />
        <Query
          query={userSegmentsQuery}
          variables={{
            name: searchText,
          }}
        >
          {({ loading, error, data }) => {
            if (error) return <SearchMenu.SearchFailure />;

            const { userSegments = { edges: [], total: 0 } } = data;

            return (
              <SearchMenu.Items>
                {userSegments.edges.map(({ node: { id, name } }) => (
                  <Item
                    {...getItemProps({
                      key: `userSegment-${id}`,
                      focused: focusedKey === `userSegment-${id}`,
                    })}
                    data-test-id={`filter-menu-userSegment-item-${id}`}
                  >
                    {name}
                  </Item>
                ))}
              </SearchMenu.Items>
            );
          }}
        </Query>
      </SearchMenu>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FilterMenu/UserSegmentsMenu.js